import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/login/LoginPage";
import UserTable from "./pages/userTable/UserTable";
import MobileDesktopWarning from "./components/MobileDesktopWarning/MobileDesktopWarning";
import MainTeam from "./pages/mainTeam/MainTeam";
import MyTeam from "./pages/myTeam/MyTeam";
import AddTeamMember from "./pages/addTeamMember/AddTeamMember";
import PlanSelection from "./pages/subscriptionPlans/PlanSelection";
import MainAddTeamMember from "./pages/mainAddTeamMember/AddTeamMember";
import MainEditTeamMember from "./pages/mainEditTeamMember/EditTeamMember";
import AssignMemberScreen from "./pages/assignMemberScreen/AssignMemberScreen";
import DashboardBrand from "./pages/dashboard/Dashboard";
import BrandVoice from "./pages/brandVoice/BrandVoice";
import MainManageBots from "./pages/mainManageBots/MainManageBots";
import PaymentSuccess from "./pages/paymentSuccess/PaymentSuccess";
import { ToastProvider } from "./components/common/ToastManager/ToastContext";
import LoginSuccess from "./pages/login/LoginSuccess";
import FreshdeskHelp from "./components/freshdesk/FreshdeskHelp";
import VerifysEmail from "./pages/verifyEmail/VerifysEmail";
import TasksTrials from "./pages/tasksTrials/TasksTrials";
import EmailScreen from "./pages/emailScreen/EmailScreen";
import PaymentFailed from "./pages/paymentFailed/PaymentFailed";
import MainContainer from "./pages/mainContainer/MainContainer";
import MainTutorial from "./pages/mainTutorial/MainTutorial";
import MainApps from "./pages/mainApps/apps";
import MainManageShopifyApp from "./pages/mainApps/MainManageShopifyApp";
import { getUserRole } from "./utils/tokenUtils";

const AdminRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const role = getUserRole();
  return role === "Admin" ? element : <Navigate to="/user/dashboard" replace />;
};


const App = () => {
  return (
    <ToastProvider>
      <MobileDesktopWarning />
      <Routes>
        {/* Non-sidebar routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/users" element={<UserTable />} />
        <Route path="/team" element={<MainTeam />} />
        <Route path="/tutorial" element={<MainTutorial />} />
        <Route path="/myteam" element={<MyTeam />} />
        <Route path="/team/add" element={<AddTeamMember />} />
        <Route path="/planselection" element={<PlanSelection />} />
        <Route path="/addteammember" element={<MainAddTeamMember />} />
        <Route path="/editteammember" element={<MainEditTeamMember />} />
        <Route path="/assignmemberscreen" element={<AssignMemberScreen />} />
        <Route path="/admindashboard" element={<DashboardBrand />} />
        <Route path="/brands" element={<BrandVoice activeTab="brands" />} />;
        <Route path="/managebots" element={<MainManageBots />} />
        <Route path="/apps" element={<AdminRoute element={<MainApps />} />} />
        <Route path="/apps/shopify" element={<AdminRoute element={<MainManageShopifyApp />} />} />

        <Route path="/paymentsuccess" element={<PaymentSuccess />} />
        <Route path="/paymentfailed" element={<PaymentFailed />} />
        <Route path="/user/*" element={<MainContainer userType="user" />} />
        <Route path="/admin/*" element={<MainContainer userType="admin" />} />
        <Route path="/login/success" element={<LoginSuccess />} />
      </Routes>
      <FreshdeskHelp />
    </ToastProvider>
  );
};

export default App;
